import {
  $getRoot,
  EditorState,
  ElementNode,
  LexicalNode,
  TextNode,
} from 'lexical';

export const getAllTextContent = (editorState: EditorState): string => {
  let text = '';

  editorState.read(() => {
    const visit = (node: LexicalNode) => {
      if (node instanceof TextNode) {
        text += `${node.getTextContent()} `;
      } else if (
        'getTextContent' in node &&
        typeof node.getTextContent === 'function' &&
        node.getType() !== 'root'
      ) {
        text += `${node.getTextContent()} `;
      } else if (node instanceof ElementNode) {
        node.getChildren().forEach((child) => visit(child));
      }
    };

    visit($getRoot());
  });

  return text.trim();
};
